<template>
  <div class="myfooter" @click="toDownloadpage">
    <p v-if="isContent" class="isText">{{isContent}} <img src="../../assets/voiceRight.png" class="isRight"></p>
    <p v-else>下载听见广播 ></p>
  </div>
</template>

<script>
export default {
  name: 'share',
  props: ['isFrom','isContent'],
  created(){
   
  },
  methods:{
      toDownloadpage(){
        if (this.isFrom) {
          if (this.isFrom.name=='lifeLive') {
             this.$router.push({path:'downloadApp?isFrom=lifeLive&is_live='+this.isFrom.isLive+'&number='+this.isFrom.number})
          }
        }else{
          this.$router.push({path:"downloadApp?isFrom=programRecorded"});
          //  this.$router.push({
          //   path:'downloadPage',
          //   name:'downloadPage'
          // })
        }
      }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .myfooter{
  width: 100%;
  height:1rem;
  line-height:1rem;
  box-sizing: border-box;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  background:rgba(235,76,76,1);
  z-index: 100;
  align-items: center;
  overflow: hidden;
  justify-content: space-between;
  font-size: .3rem;
  color:#fff;
  text-align: center;
} 
.isText{
  letter-spacing: 2px;
}
.isRight{
  width: 0.22rem;
  height: 0.22rem;
}
</style>
